// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2Ov6n","balanceDisclaimer":"posDashboard_balanceDisclaimer__u3wLD"};